import { useContext } from "react";
import { useState } from "react";
import Header from "../components/header";
import CookieBanner from "../components/cookie-banner";
import AppsLogin from "./apps-login";
import CookiePolicy from "./cookie-policy";
import ForgotPassword from "./forgot-password";
import Footer from "../components/footer";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useTealiumOnPageLoad from "../utils/tealium";
import CmsPage from "../components/cms-page";
import AppError from "../components/app-error";
import CheckUpBody from "../components/check-up/check-up-body";
import UserContext from "../context/user";
import CheckUpContext from "../context/check-up";

const APP = "CHECK_UP_SANITARIO";

const CheckUpSanitario = () => {
  const { logged } = useContext(UserContext);
  const {
    survey,
    error,
    labels,
    status,
    navigation,
    setNavigation,
    appLang,
    setAppLang,
    languages,
    checkUpInfo,
  } = useContext(CheckUpContext);
  const [forgotPw, setForgotPw] = useState();

  useTealiumOnPageLoad({ pageSection1: "welfare", pageSection2: "Check-up sanitario" });
  useDocumentTitle("EssilorLuxottica Check-up sanitario");

  return (
    <>
      {error ? (
        <AppError error={error} labels={labels} />
      ) : logged ? (
        Object.entries(labels).length === 0 ? (
          <div className="loading-spinner mt" />
        ) : (
          <>
            <Header
              selectedLanguage={appLang}
              setSelectedLanguage={setAppLang}
              languages={languages}
              labels={labels}
              app={APP}
              appTitle={survey?.title}
            />
            <main className="app-content check-up-content">
              {["privacy-policy", "cookie-policy"]?.includes(navigation) ? (
                {
                  "privacy-policy": (
                    <CmsPage
                      path="footer/privacy-policy"
                      title={labels?.WELFARE_PRIVACY_POLICY}
                      setNavigation={setNavigation}
                      key={navigation}
                      appLang={appLang}
                    />
                  ),
                  "cookie-policy": (
                    <CookiePolicy logged={true} setNavigation={setNavigation} appLang={appLang} />
                  ),
                }[navigation]
              ) : error ? (
                <AppError error={error} />
              ) : !survey && status !== "invalid-campaign" ? (
                <div className="loading-spinner mt" />
              ) : (
                <CheckUpBody />
              )}
            </main>
            <Footer
              setNavigation={setNavigation}
              app={APP}
              labels={labels}
              title={checkUpInfo?.title}
            />
          </>
        )
      ) : forgotPw ? (
        <ForgotPassword setForgotPw={setForgotPw} labels={labels} />
      ) : navigation === "cookie-policy" ? (
        <CookiePolicy logged={false} setNavigation={setNavigation} appLang={appLang} />
      ) : (
        <AppsLogin app={APP} setForgotPw={setForgotPw} labels={labels} />
      )}
      <CookieBanner labels={labels} setNavigation={setNavigation} />
    </>
  );
};

export default CheckUpSanitario;
